var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DCA1B26B-6AAF-4EC6-A639-D82B6CFF0E21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-561.000000, -516.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone-Button",
    transform: "translate(561.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-4",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 130,
    height: 22
  }), /*#__PURE__*/React.createElement("text", {
    id: "+1-(296)-699-3652",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5.5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 17,
    fill: "#000000"
  }, "+1 (296) 699-3652")), /*#__PURE__*/React.createElement("text", {
    id: "Name-Surname",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 9,
    fill: "#909090"
  }, "Name Surname")), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(111.333333, 3.666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 6.66666667,
    cy: 6.66666667,
    r: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Phone_56382",
    transform: "translate(3.666667, 4.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60997713,4.76172481 C5.28890982,5.53145503 4.53612097,5.6663562 4.29012471,5.6663562 C4.21788772,5.6663562 3.09289255,5.72599738 1.47571594,4.19201612 C0.174253408,2.95750035 0.015231251,1.62996448 0.0013758551,1.3777333 C-0.0121016664,1.13205194 0.0582459573,0.515738737 0.906070227,0.0578179033 C1.01111932,0.0010737592 1.21939111,-0.0240548906 1.27317524,0.0297292371 C1.29704431,0.0535983054 2.00864484,1.2245682 2.02734963,1.2633633 C2.04605441,1.30209543 2.0554383,1.34026075 2.0554383,1.37767032 C2.0554383,1.43113955 2.01733596,1.49802333 1.9410683,1.57825866 C1.86486362,1.658494 1.78198316,1.73205356 1.69236394,1.79887435 C1.60274472,1.86575813 1.51986427,1.93660959 1.44359661,2.0114917 C1.36739193,2.08631084 1.32928959,2.14790437 1.32928959,2.19602038 C1.33445388,2.32090788 1.43679487,2.76824823 2.2164128,3.4532716 C2.9961567,4.13848391 3.37176388,4.33151476 3.40785089,4.34486633 C3.44400088,4.35821789 3.4740419,4.36483069 3.4980999,4.36483069 C3.54627889,4.36483069 3.60780945,4.32679133 3.68269156,4.25058666 C3.7575107,4.174319 4.00923805,3.82931964 4.08947339,3.75305199 C4.16970873,3.67691029 4.2365925,3.63880795 4.29012471,3.63880795 C4.32753428,3.63880795 4.36563662,3.64812885 4.40436875,3.66683364 C4.44316386,3.68553842 5.61564525,4.37163243 5.6380658,4.39455682 C5.69890358,4.4569061 5.65595185,4.65151143 5.60997713,4.76172481",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(94.666667, 3.666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 6.66666667,
    cy: 6.66666667,
    r: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_message_3952702",
    transform: "translate(3.666667, 4.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06306306,0 C4.75474608,0 6.12612613,1.09992033 6.12612613,2.45674083 C6.12612613,3.81356132 4.75474608,4.91348165 3.06306306,4.91348165 C2.98618258,4.91348165 2.90996363,4.91120993 2.83450488,4.90674561 C2.53279829,5.14219277 1.30837643,5.86592727 0.990577487,5.61424794 C0.671424779,5.36149651 1.0963507,5.19113813 1.42136038,4.52558504 L1.41914782,4.53005523 C0.565928591,4.09395403 0,3.32835503 0,2.45674083 C0,1.09992033 1.37138005,0 3.06306306,0 Z",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneButton);
export default __webpack_public_path__ + "static/media/PhoneButton.bb8b8d24bcb2c32bc9e2fc62cd3ff891.svg";
export { ForwardRef as ReactComponent };